module.exports = __webpack_public_path__ + "media/usp-barcode-e8eb86b3.svg";